<!-- Snackbar -->
<ng-container *ngIf="snackbarService?.snackbar() as snackBar">
    <tec-snackbar
        [show]="snackBar?.show"
        [label]="snackBar?.text"
        (close)="snackbarService.hide()"
    ></tec-snackbar>
</ng-container>

<!-- Confirmation modal -->
<ng-container *ngIf="modalConfirmationService.modal() as confirmation">
    <tec-modal
        type="confirmation"
        [isVisible]="confirmation.show"
        [buttonSecondaryLabel]="confirmation?.buttonSecondaryLabel"
        [buttonPrimaryLabel]="confirmation?.buttonPrimaryLabel"
        [buttonPrimaryStyle]="confirmation?.buttonPrimaryStyle"
        (closeEvent)="modalConfirmationService.setCloseModalConfirmation($event, confirmation.id)">
        <ng-container body>
            <tec-tag-icon
                [size]="'default'"
                [icon]="confirmation.icon"
                [status]="confirmation.iconStatus"
            ></tec-tag-icon>
            <div class="body__text">
                <h4 [innerHTML]="confirmation?.title"></h4>
                <span [innerHTML]="confirmation?.description"></span>
            </div>
        </ng-container>
    </tec-modal>
</ng-container>

<!-- Loading -->
<ng-container *ngIf="loading.loading() as loader">
    <tec-spinner
        *ngIf="loader.show"
        [show]="loader.show"
        [text]="loader.text"
        [opaque]="loader.opaque"
        [watermark]="loader.watermark"
    ></tec-spinner>
</ng-container>

<router-outlet/>
